module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-03-aeec38d65228bff867c27b434070327d.jpg";